import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const store = new Vuex.Store({
    state: {
        userProfile: null,
        isLogin: false,
        fromCallSettings: null,
        loginProcess:false,
        isProfileLoad:false
    },
    actions: {
   
    }, 
    mutations: {
        setUserProfile(state, val) {            
            state.userProfile = val;
            if (val) {
                state.isLogin = true;
                state.loginProcess = false;
            }
            else state.isLogin = false;
            state.isProfileLoad =true;
        },
        setLogoutUser(state,val){
            state.userProfile = null;
            console.log('Profile', state.userProfile);
            state.isLogin = val;
        },
        setFromCallSettings(state, val) {
            state.fromCallSettings = val;
        },
        setLoginProcess(state, val) {
            state.loginProcess = val;
        },
        setIsProfileLoad(state, val) {
            state.isProfileLoad = val;
        }         
                                                                
    },
    getters: {
        userProfile: state => state.userProfile,
        isLogin: state => state.isLogin,      
        isProfileLoad: state => state.isProfileLoad,
        loginProcess: state => state.loginProcess,
        fromCallSettings: state => state.fromCallSettings
    }    
})